/* MedBound — invio lead al Google Apps Script (scrive su Google Sheet, un tab per "source").
   I popup chiamano window.mbLead(o). Niente Shopify, niente CAPTCHA: è un semplice POST a Google
   (mode:no-cors, fire-and-forget) → riga nel foglio. Poi il popup mostra la sua conferma/PDF.
   o.email (obblig.), o.phone, o.source (es. "anteprima-anatomie"|"newsletter"|"waitlist-m2"),
   o.product (etichetta leggibile), o.tags (compat: se manca source, uso l'ultimo tag). */
(function () {
  var ENDPOINT = "https://script.google.com/macros/s/AKfycbwO7K5PjsuaJaFlnCBqwCIVxOmRlWcPJ0V0HvHbimFREs0XcWAa_a3yqzAvI1rYYQFQ/exec";

  function byId(id) { return document.getElementById(id); }

  window.mbLead = function (o) {
    o = o || {};
    var email = (o.email || "").trim();
    var phone = (o.phone || "").trim();
    if (!email) return false;
    var source = o.source || (o.tags && o.tags.length ? o.tags[o.tags.length - 1] : "") || "altro";
    var page = (location.pathname.split("/").pop() || "home").replace(/\.html$/, "") || "home";

    var body = new URLSearchParams();
    body.append("source", source);
    body.append("email", email);
    body.append("phone", phone);
    body.append("name", o.name || "");
    body.append("product", o.product || o.sourceLabel || "");
    body.append("page", page);

    try {
      var p = fetch(ENDPOINT, { method: "POST", mode: "no-cors", body: body });
      if (p && p.catch) p.catch(function () {});
    } catch (e) {}

    // backup locale (utile in dev / se il fetch fallisce)
    try {
      var a = JSON.parse(localStorage.getItem("mb_leads") || "[]");
      a.push({ source: source, name: o.name || "", email: email, phone: phone, ts: new Date().toISOString() });
      localStorage.setItem("mb_leads", JSON.stringify(a));
    } catch (e) {}
    return true;
  };

  // newsletter footer (#mb-news): email + telefono OBBLIGATORI, invio + conferma
  function wireNews() {
    var form = byId("mb-news");
    if (!form || form.__mb) return;
    form.__mb = true;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var em = form.querySelector('input[name="contact[email]"]');
      var ph = form.querySelector('input[name="mb-phone"]');
      var email = em ? em.value.trim() : "";
      var phone = ph ? ph.value.trim() : "";
      var err = byId("mb-news-err");
      var ok = byId("mb-news-ok");
      function showErr(m){ if (err) { err.style.display = "block"; err.textContent = m; } }
      if (!email || !phone) { showErr("Bitte E-Mail und Telefonnummer eingeben."); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { showErr("Gib eine gültige E-Mail-Adresse ein."); return; }
      if (err) err.style.display = "none";
      window.mbLead({ email: email, phone: phone, source: "newsletter" });
      if (ok) { ok.style.display = "block"; ok.textContent = "Anmeldung gespeichert, danke!"; }
      form.reset();
    });
  }
  if (document.readyState !== "loading") wireNews();
  else document.addEventListener("DOMContentLoaded", wireNews);
})();
